import {
  // IconButton,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  // Tooltip,
  Typography,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { useMutation } from "react-query";
import moment from "moment";
import { getEmrList } from "../services";
import { EmrListParams, EmrListType, initialSearchParams } from "./types";
import { base, clinicId } from "../../constants";
import { useForm } from "react-hook-form";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { FormOnChangeEventType } from "../types";
import CustomTableBody from "../../utilis/component/CustomTableBody";
import { useNavigate } from "react-router-dom";
import useAuthentication from "../../hooks/useAuthentication";
import debounce from "../../utilis/methods/networkHandling";
import usePopup from "../../hooks/usePopup";
import moduleRoutes from "../../routes/moduleRouteList";
import PageRouterList from "../../routes/routeList";
import { lightGreen } from "@mui/material/colors";
// import DescriptionIcon from "@mui/icons-material/Description";
import ConsentFormV2 from "../components/ConsenForms/v2";
import { buildPatientFeedbackLink } from "../../PatientFeedback/buildFeedbackLink";
import { sendReviewLink } from "../../PatientFeedback/services";
// import TaskAltIcon from "@mui/icons-material/TaskAlt";

const WhatsAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="#25D366"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);
const statusText: any = {
  waiting: {
    "not started": "success.main",
    started: "error.main",
    "re-opened": "error.main",
    stopped: "error.main",
    stop: "error.main",
  },
  consultation: {
    "not started": "warning.main",
    started: "success.main",
    "re-opened": "primary.main",
    stopped: "error.main",
    stop: "error.main",
  },
};
const EmrLandingPage: FC<{ path?: string }> = ({ path }) => {
  const navigateTo = useNavigate();
  const theme = useTheme();
  const { user } = useAuthentication();
  const { showSnackbar, CustomModal } = usePopup();
  const inEmr =
    path ==
    `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${PageRouterList.emr}/`;
  const [searchParams, setSearchParams] = useState<EmrListParams>({
    ...initialSearchParams,
    userType: user?.groupId,
  });
  const [fetchTime, setFetchTime] = useState<moment.Moment | null>(null);
  const [openConsent, setOpenConsent] = useState(false);
  const [sendReviewLoadingIndex, setSendReviewLoadingIndex] = useState(-1);
  const [
    selectedPatient, 
    // setSelectedPatient
  ] = useState<EmrListType | null>(
    null,
  );
  const { mutate, data, isLoading } = useMutation(getEmrList, {
    onSuccess: () => {
      setFetchTime(moment());
    },
    onError: (e: any) => {
      showSnackbar({
        message: e.response.data.responseMessage || "Something went wrong !",
        open: true,
        variant: "warning",
        duration: 3000,
      });
    },
  });

  const { mutate: sendReviewLinkMutation, isLoading: isSendReviewLoading } =
    useMutation(sendReviewLink, {
      onSuccess: (result) => {
        if (result.responseIndicator === "success") {
          showSnackbar({
            message: result.responseMessage || "Review link sent successfully",
            open: true,
            variant: "success",
            duration: 3000,
          });
        } else {
          showSnackbar({
            message: result.responseMessage || "Failed to send review link",
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 3000,
        });
      },
      onSettled: () => {
        setSendReviewLoadingIndex(-1);
      },
    });
  const { control, setValue } = useForm();

  const handleSearch = (e: FormOnChangeEventType) => {
    const { name, value } = e.target;
    const filter = {
      ...searchParams.filter,
      [name]: value,
    };
    if (filter.searchText == "") {
      delete filter.searchText;
    }
    setSearchParams({
      ...searchParams,
      pageNumber: 0,
      filter,
    });
  };

  const onChange = debounce(handleSearch, 500);
  const handleNavigate = (patient: EmrListType) => {
    if (inEmr) {
      navigateTo(
        `${path}${patient.encounterID}/${patient.patientId}?emrno=${patient.emrNo}`,
      );
    }
  };

  const handleSendReviewLink = (
    event: React.MouseEvent,
    row: EmrListType,
    index: number,
  ) => {
    event.stopPropagation();

    const activeClinicId = Number(user?.clinicId || clinicId);
    const tenantClinicId = String(user?.tenantClinicId || "");
    if (!activeClinicId || !tenantClinicId || !row.encounterID || !row.patientId) {
      showSnackbar({
        message: "Missing clinic, tenant, or patient details to send review link",
        open: true,
        variant: "warning",
        duration: 3000,
      });
      return;
    }

    const baseLink = buildPatientFeedbackLink(activeClinicId, row.patientId);
    const separator = baseLink.includes("?") ? "&" : "?";
    const link = `${baseLink}${separator}tenantClinicId=${encodeURIComponent(
      tenantClinicId,
    )}`;
    setSendReviewLoadingIndex(index);
    sendReviewLinkMutation({
      encounterId: row.encounterID,
      link,
    });
  };
  const handleChangePage = (_: unknown, pageNumber: number) => {
    setSearchParams({
      ...searchParams,
      pageNumber,
    });
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchParams({
      ...searchParams,
      pageSize,
    });
  };

  const list = useMemo(() => {
    if (data?.response.psearchResponses) {
      console.log(
        " data.response.psearchResponses..>>>",
        data.response.psearchResponses,
      );
      return data.response.psearchResponses;
    } else {
      return [];
    }
  }, [data?.response]);

  useEffect(() => {
    setValue("searchDate", initialSearchParams.filter.searchDate);
  }, []);

  useEffect(() => {
    mutate(searchParams);
  }, [searchParams]);

  //  const regionValue= user?.region;
  //    const idHeading =
  //  regionValue === "QATAR_REGION"
  //    ? "Qatar ID"
  //    : "Emirates Id";

  const [currentTime, setCurrentTime] = useState(moment());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const parseDurationSeconds = (durationStr: string | null) => {
    if (!durationStr) return 0;
    const match = durationStr.match(/(\d+)d:(\d+)h:(\d+)m:(\d+)s/);
    if (!match) return 0;
    const [_, d, h, m, s] = match.map(Number);
    return d * 86400 + h * 3600 + m * 60 + s;
  };

  const formatSeconds = (totalSeconds: number) => {
    const d = Math.floor(totalSeconds / 86400);
    const h = Math.floor((totalSeconds % 86400) / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${d}d:${h.toString().padStart(2, "0")}h:${m
      .toString()
      .padStart(2, "0")}m:${s.toString().padStart(2, "0")}s`;
  };

  const getRunningDuration = (
    serverDurationStr: string | null,
    isRunning: boolean,
  ) => {
    if (!serverDurationStr) return "0d:00h:00m:00s";
    if (!isRunning || !fetchTime) return serverDurationStr;

    const serverSeconds = parseDurationSeconds(serverDurationStr);
    const elapsedSeconds = currentTime.diff(fetchTime, "seconds");
    return formatSeconds(serverSeconds + elapsedSeconds);
  };

  const isUaeRegion = user?.region === "UAE_REGION";
  const idHeading = "Civil ID";
  const heading1 = [
    "SL NO",
    "PAYMENT",
    "EMR NO/REG NO",
    "DOCTOR",
    "PATIENT NAME",
    // `  ${idHeading}/PASSPORT ID/GCC ID` ,
    `${idHeading}`,
    "PAYMENT TYPE",
    "INSURANCE TYPE",
    "INSURANCE NAME",
    ...(isUaeRegion ? [] : ["CONSENT"]),
    "REVIEW LINK",
  ];
  const heading2 = [
    "SL NO",
    "PAYMENT",
    "EMR NO/REG NO",
    "DOCTOR",
    "PATIENT NAME",
    // `  ${idHeading}/PASSPORT ID/GCC ID` ,
    `${idHeading}`,
    "PAYMENT TYPE",
    "INSURANCE TYPE",
    "INSURANCE NAME",
    "WAITING TIME",
    "CONSULTATION TIME",
    "REVIEW LINK",
    // "CONSENT",
  ];
  return (
    <div className="px-3 pt-4">
      <Paper className="flex flex-col gap-2">
        <TableContainer className="min-h-[80dvh] max-h-[80vh] relative ">
          <div className="px-4 py-2 border-b">
            <Typography variant="h6">Registered Patients</Typography>
          </div>
          <form className="py-4 px-2 grid grid-cols-4 gap-2">
            <CustomFormField
              control={control}
              element="datepicker"
              fieldProps={{ label: "Search date" }}
              name="searchDate"
              rules={{ required: false, onChange }}
            />
            <CustomFormField
              control={control}
              element="input"
              fieldProps={{ label: "Search name" }}
              name="searchText"
              rules={{ required: false, onChange }}
            />
          </form>
          <Table size="small" aria-label="simple table" className="border-b">
            <TableHead
              sx={{
                backgroundColor: theme.palette.background.paper,
              }}
              className="sticky w-full top-0 bg-inherit z-50"
            >
              <TableRow>
                {(user?.calendar == "NORMAL_CALENDAR"
                  ? heading1
                  : heading2
                ).map((title, index) =>
                  title == "PAYMENT" ? (
                    inEmr && (
                      <TableCell key={`${title}${index}`}>
                        <strong>{title}</strong>
                      </TableCell>
                    )
                  ) : (
                    <TableCell
                      key={`${title}${index}`}
                      align={
                        title === "WAITING TIME" ||
                        title === "CONSULTATION TIME" ||
                        title === "REVIEW LINK"
                          ? "center"
                          : "left"
                      }
                    >
                      <strong>{title}</strong>
                    </TableCell>
                  ),
                )}
              </TableRow>
            </TableHead>
            <CustomTableBody
              alert={"No records"}
              dataLoading={isLoading}
              isData={list.length > 0}
              totalSpan={{
                col: inEmr
                  ? user?.calendar == "NORMAL_CALENDAR"
                    ? heading1.length
                    : heading2.length
                  : (user?.calendar == "NORMAL_CALENDAR"
                      ? heading1.length
                      : heading2.length) - 1,
                row: 10,
              }}
            >
              {list.map((row, index) => (
                <TableRow
                  onClick={() => {
                    handleNavigate(row);
                  }}
                  hover={inEmr ? row?.isCashed == 0 : true}
                  key={`emrlistId${index}`}
                  sx={
                    inEmr
                      ? rowStyle[`${row?.isCashed}` as keyof typeof rowStyle]
                      : rowStyle["0"]
                  }
                >
                  <TableCell align="center">
                    {searchParams.pageNumber * searchParams.pageSize +
                      index +
                      1}
                  </TableCell>

                  {inEmr && (
                    <TableCell>
                      {row?.isCashed == 1 && inEmr ? (
                        <span>
                          <Typography fontSize={12} color="success.main">
                            Cashed
                          </Typography>
                        </span>
                      ) : (
                        <span />
                      )}
                    </TableCell>
                  )}

                  <TableCell>{row.emrNo || "-"}</TableCell>
                  <TableCell>{row.doctorName || "-"}</TableCell>
                  <TableCell>{row.fullName || "-"}</TableCell>
                  <TableCell>
                    {row.emiratesId || row.passportNum || row.gccId || "-"}
                  </TableCell>
                  <TableCell>{row.paymentType || "-"}</TableCell>
                  <TableCell>
                    {row.paymentType == "Cash"
                      ? "-"
                      : row?.insuranceType || "-"}
                  </TableCell>
                  <TableCell>
                    {row.paymentType == "Cash"
                      ? "-"
                      : row?.insuranceName || "-"}
                  </TableCell>
                  {user?.calendar != "NORMAL_CALENDAR" && (
                    <>
                      <TableCell align="center">
                        <div>
                          <div className="flex items-center gap-1">
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color:
                                  statusText.waiting[
                                    row.consultationStatus?.toLowerCase() || ""
                                  ] || "success.main",
                              }}
                            >
                              {row.waitingTime
                                ? getRunningDuration(
                                    row.waitingTime,
                                    row.consultationStatus?.toLowerCase() ===
                                      "not started",
                                  )
                                : "-"}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell align="center">
                        <div>
                          <div className="flex items-center gap-1">
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color:
                                  statusText.consultation[
                                    row.consultationStatus?.toLowerCase() || ""
                                  ] || "error.main",
                              }}
                            >
                              {row.consultationStatus?.toLowerCase() ==
                              "not started"
                                ? row.consultationStatus
                                : row.consultationTime
                                  ? getRunningDuration(
                                      row.consultationTime,
                                      row.consultationStatus?.toLowerCase() ===
                                        "started" ||
                                        row.consultationStatus?.toLowerCase() ===
                                          "re-opened",
                                    )
                                  : "-"}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>
                    </>
                  )}
                  <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                    <Tooltip title="Send review link via WhatsApp" arrow placement="top">
                      <span>
                        <IconButton
                          size="small"
                          disabled={
                            isSendReviewLoading && sendReviewLoadingIndex === index
                          }
                          onClick={(event) =>
                            handleSendReviewLink(event, row, index)
                          }
                          sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: 2,
                          }}
                        >
                          {isSendReviewLoading &&
                          sendReviewLoadingIndex === index ? (
                            <CircularProgress size={18} />
                          ) : (
                            <WhatsAppIcon />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </TableCell>
                  {/* <TableCell align="center">
                    <Tooltip title="View Consent Forms" arrow placement="top">
                      <IconButton
                        size="small"
                        color="primary"
                        sx={{
                          bgcolor: "primary.50",
                          "&:hover": {
                            bgcolor: "primary.100",
                            transform: "scale(1.05)",
                          },
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedPatient(row);
                          setOpenConsent(true);
                        }}
                      >
                        <DescriptionIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                  </TableCell> */}
                </TableRow>
              ))}
            </CustomTableBody>
          </Table>
        </TableContainer>
        <div className="border-t">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data?.response?.count || 0}
            rowsPerPage={searchParams.pageSize}
            page={searchParams.pageNumber}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
      <CustomModal
        open={openConsent}
        setOpen={setOpenConsent}
        title="Consent Forms"
      >
        <ConsentFormV2
          encounterId={selectedPatient?.encounterID}
          emrNo={selectedPatient?.emrNo}
        />
      </CustomModal>
    </div>
  );
};

export default EmrLandingPage;

const rowStyle = {
  "0": {
    "&:last-child td, &:last-child th": { border: 0 },
    cursor: "pointer",
    bgcolor: "",
  },
  undefined: {
    "&:last-child td, &:last-child th": { border: 0 },
    cursor: "pointer",
    bgcolor: lightGreen[100],
  },
  "1": {
    "&:last-child td, &:last-child th": { border: 0 },
    // cursor: "default",
    cursor: "pointer",
    bgcolor: lightGreen[100],
  },
};
